var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticClass:"title"},[_vm._v("线索信息")]),_c('blockList',{staticClass:"list",attrs:{"list":_vm.list,"labelWidth":"100"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }